import { render, staticRenderFns } from "./commercialmemberimage.vue?vue&type=template&id=a2be37d0&scoped=true"
import script from "./commercialmemberimage.vue?vue&type=script&lang=js"
export * from "./commercialmemberimage.vue?vue&type=script&lang=js"
import style0 from "./commercialmemberimage.vue?vue&type=style&index=0&id=a2be37d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2be37d0",
  null
  
)

export default component.exports